module.exports = "<div class=\"container-full\">\n  <div class=\"page-header\">\n    <h3>语言分布统计</h3>\n  </div>\n  <div class=\"\">\n    <table class=\"table table-striped\">\n      <thead>\n        <tr>\n          <th style=\"width: 50px;\"></th>\n          <th>语言</th>\n          <th>数量</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"item in firmwaresLangCtrl.data\">\n          <td>{{$index + 1}}</td>\n          <td>{{item._id}}</td>\n          <td>{{item.count}}</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/firmwares/lang/lang.html
// module id = 151
// module chunks = 0